// extracted by mini-css-extract-plugin
export var paginationContainer = "_85-0";